import 'devbridge-autocomplete';
import { enableMapSet } from 'immer';
import Sortable from 'sortablejs';

import calendar from './calendar';
import Cookie from './components/Cookie';
import './conditional';
import './icon';
import { initMenu } from './menu';
import { Print } from './print';
import './repeater';
import './select2';
import { initTicketOffice } from './ticket_office';
import ticketValidation from './ticket_validation';
import { ValidationScanner } from './validation_scanner';
import { initEditGrid } from './edit_grid';
import { initPaymentButtons } from './payment_buttons';
import * as Sentry from '@sentry/react';

if (process.env.NODE_ENV === 'production') {
    Sentry.init({
        dsn: 'https://0d749beb2353ed010948c91dab6da2b6@o4507423572295680.ingest.de.sentry.io/4507492791943248',
        environment: process.env.NODE_ENV,
        // Only report errors originating from a Kinola-owned host, so the global
        // window.onerror handler does not capture browser-extension or
        // third-party script noise.
        allowUrls: [/\/\/([\w-]+\.)*kinola\.\w{2,}/i, /localhost/],
        // fetch() rejects with these when no HTTP response arrives (connection
        // dropped, page left mid-request), worded differently per browser. They
        // say nothing about Kinola; server failures arrive with a status code.
        ignoreErrors: [/^(Failed to fetch|Load failed|NetworkError when attempting to fetch resource)/],
    });
}

$('.autocomplete').each(({}: number, item: HTMLElement) => {
    const element: JQuery<HTMLElement> = $(item);

    if (element.data('service-url')) {
        const valueInputName: string = element.data('value-input');

        element.devbridgeAutocomplete({
            dataType: 'json',
            deferRequestBy: 300,
            groupBy: 'category',
            minChars: 1,
            onSelect: (suggestion: AutocompleteSuggestion): void => {
                if (valueInputName && suggestion.data.value) {
                    $('input[name="' + valueInputName + '"]')
                        .val(suggestion.data.value)
                        .trigger('change');
                }

                if (suggestion.data.ticket) {
                    $('[data-content="ticket-details"]').html(suggestion.data.ticket);
                }
            },
            onSearchComplete: (query: string, suggestions: AutocompleteSuggestion[]): void => {
                if (suggestions.length === 1) {
                    suggestions.forEach((suggestion: AutocompleteSuggestion): void => {
                        if (suggestion.data.ticket) {
                            $('[data-content="ticket-details"]').html(suggestion.data.ticket);
                        }
                    });
                }
            },
            serviceUrl: element.data('service-url'),
        });
    }
});

$(window).on('load', (): void => {
    if ($('.js-calendar').length) {
        calendar.init();
    }

    if ($('.js-checkout').length) {
        initTicketOffice();
    }

    if ($('.js-edit-grid').length) {
        initEditGrid();
    }

    if ($('.js-payment-buttons').length) {
        initPaymentButtons();
    }

    if (!$('.voyager').length) {
        return;
    }

    enableMapSet();
    $('.modal.open-on-load').modal('show');
    initMenu();
    ticketValidation.init();
    const validationScanner: ValidationScanner = new ValidationScanner();
    const print: Print = new Print();

    document.querySelectorAll('.sortable-items').forEach((element: HTMLElement): void => {
        Sortable.create(element, {
            handle: '.sortable-handle',
        });
    });
});

$(document).on('click', '[data-toggle="modal"]', (event: JQuery.ClickEvent): void => {
    $($(event.currentTarget).attr('href')).modal('show');
});

if (!Cookie.get('cashierHash')) {
    Cookie.set(
        'cashierHash',
        `${Date.now().toString(36).substring(2)}${(Math.random() + 1).toString(36).substring(7)}`,
        24 * 60 * 31 * 12
    );
}
